import { FreelancerOnboardingStatus } from "../models/enums/FreelancerOnboardingStatus";

// The internal-user context is typed as the numeric enum but actually carries
// enum names (from InternalMenu) or raw localStorage strings after a reload,
// so the runtime value can be 0, "0" or "NotSubmitted". A plain reverse lookup
// maps "NotSubmitted" to 0, which then reads as a missing filter.
export const toOnboardingStatusName = (
	status: FreelancerOnboardingStatus | "All"
): string | undefined => {
	if (status === "All") return undefined;

	const name = FreelancerOnboardingStatus[status];
	return typeof name === "string" ? name : String(status);
};
